import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

function EditGuestModal({ guestData, onClose, onUpdate }) {
  const [names, setNames] = useState("");
  const [type, setType] = useState(""); // Заменили via на type
  const [admissionType, setAdmissionType] = useState("FREE");
  const [customDiscount, setCustomDiscount] = useState(50);
  const [notes, setNotes] = useState("");
  const [plus, setPlus] = useState(0);
  const [category, setCategory] = useState("REGULAR"); // Добавляем состояние категории

  // Подтягиваем данные из guestData при монтировании компонента
  useEffect(() => {
    if (guestData) {
      setNames(guestData.name || "");
      setType(guestData.type || ""); // Заменили setVia на setType и via на type
      setAdmissionType(guestData.admission.includes("%") ? "DISCOUNT" : "FREE");
      setCustomDiscount(
        guestData.admission.includes("%") ? parseInt(guestData.admission.replace("%", ""), 10) : 50
      );
      setNotes(guestData.notes || "");
      setPlus(guestData.plus || 0);
      setCategory(guestData.category || "REGULAR"); // Подтягиваем категорию гостя
    }
  }, [guestData]);

  const handleUpdate = () => {
    const updatedGuestData = {
      id: guestData.id,
      names,
      type: type,
      via: type,
      admission: admissionType === "DISCOUNT" ? `${customDiscount}%` : "FREE",
      notes,
      plus,
      category, // Добавляем категорию в обновленные данные
    };
    console.log("Данные перед отправкой из EditGuestModal:", updatedGuestData);
    onUpdate(updatedGuestData);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-lg p-4 w-[350px] relative">
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-700 transition duration-200"
          aria-label="Close"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        <h3 className="text-lg font-bold mb-3">Edit Guest</h3>
        
        <div className="mb-3">
          <label className="block text-sm font-medium text-gray-700 mb-1">Names</label>
          <input
            type="text"
            className="w-full border rounded-md p-1.5 text-sm"
            placeholder="Enter guest name, e.g., John Doe"
            value={names}
            onChange={(e) => setNames(e.target.value)}
          />
        </div>
        
        <div className="mb-3">
          <label className="block text-sm font-medium text-gray-700 mb-1">Via</label>
          <input
            type="text"
            className="w-full border rounded-md p-1.5 text-sm"
            placeholder="Enter source, e.g., Admin"
            value={type}
            onChange={(e) => setType(e.target.value)}
          />
        </div>
        
        {/* Добавляем селектор категории */}
        <div className="mb-3">
          <label className="block text-sm font-medium text-gray-700 mb-1">Status</label>
          <select
            className="w-full border rounded-md p-1.5 text-sm"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
          >
            <option value="REGULAR">Regular</option>
            <option value="VIP">VIP</option>
            <option value="BACKSTAGE">Backstage</option>
            <option value="ARTIST">Artist</option>
            <option value="STAFF">Staff</option>
        </select>
        </div>
        
        <div className="mb-3">
          <div className="flex space-x-4 items-start">
            <div className="flex-1">
              <label className="block text-sm font-medium text-gray-700 mb-1">Admission</label>
              <div className="flex items-center space-x-3">
                <label className="flex items-center text-sm">
                  <input
                    type="radio"
                    name="admission"
                    value="FREE"
                    checked={admissionType === "FREE"}
                    onChange={() => setAdmissionType("FREE")}
                    className="mr-1 h-3.5 w-3.5"
                  />
                  Free
                </label>
                <label className="flex items-center text-sm">
                  <input
                    type="radio"
                    name="admission"
                    value="DISCOUNT"
                    checked={admissionType === "DISCOUNT"}
                    onChange={() => setAdmissionType("DISCOUNT")}
                    className="mr-1 h-3.5 w-3.5"
                  />
                  <span className="flex items-center">
                    <input
                      type="number"
                      min={0}
                      max={100}
                      value={customDiscount}
                      onChange={(e) => {
                        const val = e.target.value;
                        const newVal = val === "" ? 0 : Number(val);
                        const limitedVal = Math.min(100, Math.max(0, newVal));
                        setCustomDiscount(limitedVal);
                      }}
                      onFocus={(e) => e.target.select()}
                      className="w-12 border rounded p-1 text-center text-sm"
                      disabled={admissionType !== "DISCOUNT"}
                    />
                    %
                  </span>
                </label>
              </div>
            </div>
            <div className="ml-2">
              <label className="block text-sm font-medium text-gray-700 mb-1">Plus</label>
              <input
                type="number"
                min={0}
                className="w-16 border rounded p-1 text-center text-sm"
                placeholder="0"
                value={plus}
                onChange={(e) => {
                  const val = e.target.value;
                  const newVal = val === "" ? 0 : Number(val);
                  setPlus(newVal);
                }}
                onFocus={(e) => e.target.select()}
              />
            </div>
          </div>
        </div>
        
        <div className="mb-3">
          <label className="block text-sm font-medium text-gray-700 mb-1">Notes</label>
          <textarea
            className="w-full border rounded-md p-1.5 text-sm"
            rows={2}
            placeholder="Additional notes"
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
          />
        </div>
        
        <div className="flex justify-center space-x-4 mt-4">
          <button
            onClick={handleUpdate}
            className="px-5 py-1.5 rounded-md bg-indigo-600 text-white text-sm font-medium hover:bg-indigo-700 transition disabled:opacity-50 disabled:cursor-not-allowed"
            disabled={!names.trim()}
          >
            Update
          </button>
          <button
            onClick={onClose}
            className="px-5 py-1.5 rounded-md bg-white text-gray-700 text-sm font-medium border border-gray-300 hover:bg-gray-100 transition"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}

EditGuestModal.propTypes = {
  guestData: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
};

export default EditGuestModal;